<div [class]="'main ' + getStyleClass()" (click)="sortRequested($event)" [style.height]="tableColumn?.rotate90 ? table?.headerHeight + 'px' : undefined" (click)="click($event)">
    @if (params.context.table.useTableMenu && isFirstColumn()) {
    <i class="fas fa-cog mouse-pointer" (click)="menuClicked($event)">
    </i>
    }
    <div class="customHeaderLabel" [class.rotated-text]="tableColumn?.rotate90" [pTooltip]="tableColumn?.toolTip">
        @if(!_Utils.isNoe(tableColumn?.icon)) {
            <i [class]="tableColumn.icon"></i>
        }
        @if(tableColumn?.keepHtmlHeader) {
            <span [innerHTML]="params.displayName | keepHtml"></span>
        }    
        @else {
            {{params.displayName}}
        }
        @if (!_Utils.isNoe(params.column?.getColDef()?.context?.toolTip)) {
            <i class="fa fa-question" [pTooltip]="params.column?.getColDef()?.context?.toolTip"></i>
        } 
    </div>   
    @if (params.column.getSort() == 'asc') {
        <i class="ml-1 active fa fa-long-arrow-alt-down"></i>
    } 
    @if (params.column.getSort() == 'desc') {
        <i class="ml-1 active fa fa-long-arrow-alt-up"></i>
    }
    @if (table.useColumnMenu) {
        <i class="menu-button mouse-pointer fas fa-bars" (click)="columnMenuClicked($event)"></i>
    }
</div>
